import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import CheckEmailPage from "@/pages/CheckEmailPage";
import VerifyPage from "@/pages/VerifyPage";
import ManagePage from "@/pages/ManagePage";
import AdminPage from "@/pages/AdminPage";
import AuthCallback from "@/pages/AuthCallback";
import NotFoundPage from "@/pages/NotFoundPage";
import SendNowPage from "@/pages/SendNowPage";
import SharePage from "@/pages/SharePage";
import RemoveLocationPage from "@/pages/RemoveLocationPage";
import SnoozeLocationPage from "@/pages/SnoozeLocationPage";
import HourlyPage from "@/pages/HourlyPage";
import TodayPage from "@/pages/TodayPage";
import NewsLandingPage from "@/pages/NewsLandingPage";
import LoginPage from "@/pages/LoginPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import SetPasswordPage from "@/pages/SetPasswordPage";
import AppDashboard from "@/pages/AppDashboard";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsPage from "@/pages/TermsPage";
import RequireAuth from "@/components/RequireAuth";
import { AuthProvider } from "@/contexts/AuthContext";
import CapacitorBridge from "@/components/CapacitorBridge";
import { Navigate } from "react-router-dom";

function AppRouter() {
  const location = useLocation();
  // Detect OAuth session_id in URL fragment — must run synchronously during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/news" element={<NewsLandingPage />} />
      <Route path="/check-email" element={<CheckEmailPage />} />
      <Route path="/verify/:token" element={<VerifyPage />} />
      <Route path="/manage/:token" element={<ManagePage />} />
      <Route path="/send-now/:token" element={<SendNowPage />} />
      <Route path="/send-now/:token/news/:newsId" element={<SendNowPage />} />
      <Route path="/share" element={<SharePage />} />
      <Route path="/share/:kind" element={<SharePage />} />
      <Route path="/remove-location/:token/:subId" element={<RemoveLocationPage />} />
      <Route path="/snooze-location/:token/:subId" element={<SnoozeLocationPage />} />
      <Route path="/hourly/:token/:subId" element={<HourlyPage />} />
      <Route path="/hourly/:token/:subId/:date" element={<HourlyPage />} />
      <Route path="/today/:token" element={<TodayPage />} />
      {/* Legacy unsubscribe links still land here — redirect by re-using ManagePage */}
      <Route path="/unsubscribe/:token" element={<ManagePage />} />
      <Route path="/admin" element={<AdminPage />} />
      {/* New JWT auth routes */}
      <Route path="/login" element={<LoginPage />} />
      {/* /signup retired — landing page IS the signup flow now. */}
      <Route path="/signup" element={<Navigate to="/?stay=1" replace />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/set-password" element={<SetPasswordPage />} />
      <Route path="/app" element={<RequireAuth><AppDashboard /></RequireAuth>} />
      <Route path="/privacy" element={<PrivacyPolicyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CapacitorBridge />
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
